<template>
	<div>
        <vue-headful :title="'Dashboard :: MeritEHS'" />

	    <h4 class="mt-2 mb-4">
	    	<ol class="breadcrumb font-weight-bold m-0">
	    		<li class="breadcrumb-item font-weight-light d-block d-md-inline-block">
                    <router-link :to="`/`">
                        <i class="fa fa-dashboard"></i> Dashboard
                    </router-link>
                </li>
                <li class="breadcrumb-item font-weight-light d-block d-md-inline-block">
                    <router-link :to="`/dashboards/settings`">
                        Settings
                    </router-link>
                </li>
                <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2">
                    {{ dashboard.id ? 'Edit' : 'Create' }}
                </li>
	    	</ol>
	    </h4>

        <div class="row mb-4">
            <div class="col-lg-8 col-12">
                <div class="card">
                    <div class="card-header">
                        {{ dashboard.id ? 'Edit' : 'New' }} Dashboard
                    </div>
                    <div class="card-body">
                        <div class="row form-group mb-4">
                            <label class="col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.dashboard_name}">
                                Dashboard Name:  <i class="fa fa-asterisk text-danger"></i>
                            </label>
                            <div class="col-lg-6 col-md-6 col-sm-8">
                                <input type="text" v-model="dashboard.dashboard_name" :class="{'form-control': true, 'is-invalid': errors.dashboard_name}" placeholder="Enter Dashboard Name (Required)" />

                                <span v-if="errors.dashboard_name" class="text-danger">
                                    <span v-for="error in errors.dashboard_name">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="row form-group mb-4" v-if="$store.state.user.is_admin">
                            <label class="col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.is_global}">
                                Global:  <i class="fa fa-question-circle" title="If you make this a Global Dashboard, other users will be able to subscribe and clone this."></i>
                            </label>
                            <div class="col-lg-6 col-md-6 col-sm-8">
                                <b-form-checkbox v-model="dashboard.is_global" :value="1" :unchecked-value="0" plain />

                                <span v-if="errors.is_global" class="text-danger">
                                    <span v-for="error in errors.is_global">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mb-4 alert alert-warning" v-if="filters.length == 0 && !loading">
            You do not have any saved filters yet. Create saved filters from any of module list, then you can add those to custom dashboards.
            <div>For a step-by-step guide to creating saved filters and adding them to your dashboard(s), view our <a :href="$root.helpCenterUrl+'/saved-filters/creating-saved-filters'" target="_blank">The MeritEHS Documentation</a></div>
        </div>

        <div id="dashboard-rows" class="mb-4">
            <div class="card mb-3" v-for="(row,i) in rows">
                <div class="card-header">
                    Row {{ i+1 }}
                    <button type="button" class="btn btn-xs btn-default" title="Delete Row" v-on:click="removeRow(i)">
                        <i class="fa fa-remove text-danger"></i> Row
                    </button>
                    <button type="button" class="btn btn-xs btn-default" title="Add Cell" v-on:click="addCell(i)" :disabled="(row.cells.length >= 4)">
                        <i class="fa fa-plus-circle text-success"></i> Cell <span v-if="row.cells.length >= 4"> - Max 4 Cells Per Row</span>
                    </button>
                </div>

                <div class="card-body">
                    <div class="row">
                        <div v-for="(cell, j) in row.cells" :class="'col-md-'+(cell.grid_size ? cell.grid_size : 2)">
                            <div class="dash-cell">
                                <div class="row">
                                    <div class="col-md-2">
                                        <button type="button" class="btn btn-xs btn-default" title="Delete Cell" v-on:click="removeCell(i, j)">
                                            <i class="fa fa-remove text-danger"></i>
                                        </button>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="">
                                            <label :class="{'text-muted': !errors['rows.'+i+'.cells.'+j+'.data_type'], 'text-danger': errors['rows.'+i+'.cells.'+j+'.data_type']}">Cell Type:</label>
                                            <b-form-radio-group v-model="cell.data_type" class="mt-2 d-inline-block" plain :class="{'is-invalid': errors['rows.'+i+'.cells.'+j+'.data_type']}">
                                                <b-form-radio value="Filter">Saved Filter</b-form-radio>
                                                <b-form-radio value="Report">Saved Report</b-form-radio>
                                            </b-form-radio-group>

                                            <div class="text-danger" v-if="errors['rows.'+i+'.cells.'+j+'.data_type']">
                                                <span v-for="err in errors['rows.'+i+'.cells.'+j+'.data_type']">
                                                    {{ err }}
                                                </span>
                                            </div>
                                        </div>

                                        <template v-if="cell.data_type">
                                        <template v-if="cell.data_type === 'Filter'">
                                                <b-form-select v-model="cell.user_filter_id" :options="filterOptions" size="sm" :class="{'is-invalid': errors['rows.'+i+'.cells.'+j+'.user_filter_id']}" />

                                                <div class="text-danger" v-if="errors['rows.'+i+'.cells.'+j+'.user_filter_id']">
                                                    <span v-for="err in errors['rows.'+i+'.cells.'+j+'.user_filter_id']">
                                                        {{ err }}
                                                    </span>
                                                </div>

                                                <div class="mt-2">
                                                    <b-form-select v-model="cell.display_type" :options="displayTypeOptions" size="sm" :class="{'is-invalid': errors['rows.'+i+'.cells.'+j+'.display_type']}" />

                                                    <div class="text-danger" v-if="errors['rows.'+i+'.cells.'+j+'.display_type']">
                                                        <span v-for="err in errors['rows.'+i+'.cells.'+j+'.display_type']">
                                                            {{ err }}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div class="row mt-2" v-if="cell.display_type === 'total'">
                                                    <div class="col-md-5">
                                                        <b-form-input v-model="cell.min_highlight_count" size="sm" :class="{'is-invalid': errors['rows.'+i+'.cells.'+j+'.min_highlight_count']}" min="1" placeholder="Min Total to Highlight" />
                                                    </div>
                                                    <div class="col-md-5">
                                                        <b-form-select v-model="cell.label_color" :options="labelColorOptions" size="sm" :class="{'is-invalid': errors['rows.'+i+'.cells.'+j+'.label_color']}" />

                                                        <div class="text-danger" v-if="errors['rows.'+i+'.cells.'+j+'.label_color']">
                                                            <span v-for="err in errors['rows.'+i+'.cells.'+j+'.label_color']">
                                                                {{ err }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-1" v-if="cell.label_color">
                                                        <span :class="'badge badge-'+cell.label_color">
                                                            <i class="fa fa-tag"></i>
                                                        </span>
                                                    </div>
                                                </div>
                                            </template>
                                            <template v-else-if="cell.data_type ==='Report'">
                                                <b-form-select v-model="cell.user_report_id" :options="reportOptions" size="sm" :class="{'is-invalid': errors['rows.'+i+'.cells.'+j+'.user_report_id']}" />

                                                <div class="text-danger" v-if="errors['rows.'+i+'.cells.'+j+'.user_report_id']">
                                                    <span v-for="err in errors['rows.'+i+'.cells.'+j+'.user_report_id']">
                                                        {{ err }}
                                                    </span>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <span v-if="errors['rows.'+i+'.cells']" class="text-danger">
                        <span v-for="error in errors['rows.'+i+'.cells']">{{ error }}</span>
                    </span>
                </div>
            </div>

            <div class="text-center" v-on:click="addRow()" style="border: 1px dashed #ddd; background: #ffffff; padding: 8px 10px;">
                <i class="fa fa-plus-circle text-success"></i> Add Dashboard Row
            </div>

            <span v-if="errors.rows" class="text-danger">
                <span v-for="error in errors.rows">{{ error }}</span>
            </span>
        </div>

        <button type="button" class="btn btn-sm btn-success" v-on:click="saveDashboard()">
            Save Dashboard
        </button>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                dashboard_id: this.$route.params.id,
                dashboard: {},
                rows: [],
                filters: [],
                reports: [],
                errors: {},
            }
        },

        watch: {
            //IF the Globals Changes, We need to Reset all the Row Cell Filtes
            'dashboard.is_global'(newVal, oldVal){
                //IF the newVal is NOT global, we can leave all the reports AS-IS
                if(newVal == 0)
                {
                    return;
                }

                //Loop and Reset Cells
                for (var i = 0; i < this.rows.length; i++)
                {
                    for (var j = 0; j < this.rows[i].cells.length; j++)
                    {
                        //Check the ID
                        if(this.filtersById[this.rows[i].cells[j].user_filter_id].is_global !== 1)
                        {
                            //Clear it out
                            this.rows[i].cells[j].user_filter_id = null;
                        }
                    }
                }
            },
        },

        computed: {
            filterOptions(){
                //SEtup
                var options = [{value: null, text: '-- Select Saved Filter --'}];

                //Loop and Build
                for (var i = 0; i < this.filters.length; i++)
                {
                    //Check for Global
                    if(this.dashboard.is_global == 1 && this.filters[i].is_global !== 1)
                    {
                        continue;
                    }

                    //Push
                    options.push({
                        value: this.filters[i].id,
                        text: (this.filters[i].asset_type == 'CovidFormEntry' ? 'Custom Form' : this.filters[i].asset_type ) + ' - ' + this.filters[i].filter_name,
                    });
                }

                //SEnd it
                return options;
            },

            filtersById(){
                //Setup
                var filters = {};

                for (var i = 0; i < this.filters.length; i++)
                {
                    filters[this.filters[i].id] = this.filters[i];
                }

                //SEnd it
                return filters;
            },

            reportOptions(){
                //SEtup
                var options = [{value: null, text: '-- Select Saved Report --'}];

                //Loop and Build
                for (var i = 0; i < this.reports.length; i++)
                {
                    //Check for Global
                    if(this.dashboard.is_global == 1 && this.reports[i].is_global !== 1)
                    {
                        continue;
                    }

                    //Push
                    options.push({
                        value: this.reports[i].id,
                        text: this.reports[i].report_type + ' - ' + this.reports[i].report_name,
                    });
                }

                //SEnd it
                return options;
            },

            reportsById(){
                //Setup
                var reports = {};

                for (var i = 0; i < this.reports.length; i++)
                {
                    reports[this.reports[i].id] = this.reports[i];
                }

                //SEnd it
                return reports;
            },


            displayTypeOptions(){
                //SEtup
                return [
                    {value: null, text: '-- Select Display Type--'},
                    {value: 'list', text: 'List (Default)'},
                    {value: 'total', text: 'Total'},
                ];
            },

            labelColorOptions(){
                //SEtup
                return [
                    {value: null, text: '-- Select Label Color --'},
                    {value: 'info', text: 'Info'},
                    {value: 'warning', text: 'Warning'},
                    {value: 'danger', text: 'Danger'},
                    {value: 'success', text: 'success'},
                    {value: 'secondary', text: 'Secondary'},
                    {value: 'primary', text: 'Primary'},
                    {value: 'light', text: 'Light'},
                    {value: 'dark', text: 'Dark'},
                ];
            },
        },

        methods: {

            getDashboard() {
                this.$http.get('/dashboards/settings/edit' + (this.dashboard_id ? '/'+this.dashboard_id : '') )
                .then(response => {
                    //SEt it
                    this.dashboard = response.data.dashboard;
                    this.filters = response.data.filters;
                    this.reports = response.data.reports;
                    this.rows = response.data.rows;

                    //Check Route Params
                    if(this.$route.query.is_global)
                    {
                        this.dashboard.is_global = this.$route.query.is_global;
                    }

                    //Check for ID
                    if(!this.dashboard.id)
                    {
                        //Add Row
                        this.addRow();

                        //Add a Cell
                        //this.addCell(0);
                    }
                })
                .catch(err => {

                })
                .then(() => {
                    //Reset
                    this.loading = false;
                });
            },

            saveDashboard(){
                //Reset Errors
                this.errors = {};

                //SEt the rows
                this.dashboard.rows = this.rows;

                //Send it
                this.$http.post('/dashboards/settings/edit', this.dashboard)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Dashboard Saved');

                    //Send to the View
                    this.$router.push('/dashboards/settings/view/' + response.data.dashboard.id);
                })
                .catch(err => {
                    //Check for error
                    if(err.response && err.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = err.response.data;
                    }
                });
            },

            addRow(){
                //Check the Existing Length
                var rowIndex = this.rows.length;

                //Push it
                this.rows.push({
                    cells: [],
                });

                //Fire it
                this.addCell(rowIndex);
            },

            removeRow(rowIndex){
                //Send it
                this.rows.splice(rowIndex, 1);
            },

            addCell(rowIndex){
                //Check the Length of the Cells
                if(this.rows[rowIndex].cells.length >= 4)
                {
                    //Stop
                    this.$toastr.warning('A Row can only have a max of 4 report cells');

                    //Stop
                    return;
                }

                //Push
                this.rows[rowIndex].cells.push({
                    data_type: null,
                    user_filter_id: null,
                    user_report_id: null,
                    grid_size: null,
                    display_type: null,
                });

                //Set it
                this.recalculateRowCells(rowIndex);
            },

            removeCell(rowIndex, cellIndex){
                //Remove
                this.rows[rowIndex].cells.splice(cellIndex, 1);

                //Set it
                this.recalculateRowCells(rowIndex);
            },

            recalculateRowCells(rowIndex){
                //Loop through ALL the cells in the row and set the grid
                for (var i = 0; i < this.rows[rowIndex].cells.length; i++)
                {
                    //Set the Grid Size
                    this.rows[rowIndex].cells[i].grid_size = 12 / this.rows[rowIndex].cells.length;
                }
            },
        },

        mounted() {
            this.getDashboard();
        }
    }
</script>

<style type="text/css" scoped>
    .dash-cell {
        /*text-align: center;*/
        background: #f5f5f5;
        border: 1px solid #eaeaea;
        padding: 20px;
    }
</style>